import { requireAnySystemPermission, requireOrgPermission } from '../../../../../../../../backend/features/permissions/shared';
import { useContactManagementTranslation, useUserState } from '../../../../../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { Box, Checkbox } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { AccountMembershipActions } from './AccountMembershipActions';
import { AccountMembershipOrgAvatar } from './AccountMembershipOrgAvatar';
import { AccountMembershipStatus } from './AccountMembershipStatus';
export const AccountMembershipTableRow = (props) => {
    var _a;
    const { t } = useContactManagementTranslation();
    const userState = useUserState();
    const settings = useSelector(getSettings);
    const { orgRoleMap } = settings;
    const canManageMembership = requireOrgPermission(userState, props.organizationId, 'manage-members') ||
        (requireAnySystemPermission(userState, 'manage-accounts') &&
            requireAnySystemPermission(userState, 'manage-accounts-organizations'));
    const userCanDoBulkActions = requireAnySystemPermission(userState, 'all-organizations-admin');
    return (React.createElement(Box, { sx: {
            display: 'flex',
            alignItems: 'center',
            my: 1,
            width: '100%',
        }, "data-test": 'membership-table-row' },
        userCanDoBulkActions && (React.createElement(Box, { sx: { backgroundColor: themeColors.surface.secondary } },
            React.createElement(Checkbox, { inputProps: {
                    'aria-label': t('common.selectRow'),
                }, checked: props.isChecked, onChange: (_, checked) => {
                    props.onCheckboxClick(checked);
                } }))),
        React.createElement(Box, { sx: {
                width: '100%',
                border: `1px solid ${themeColors.border.main}`,
                display: 'flex',
                alignItems: 'center',
                p: 2,
                backgroundColor: themeColors.surface.primary,
                '&:hover': {
                    backgroundColor: themeColors.surface.hover,
                },
            } },
            React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', flex: '1 75%', gap: 2 } },
                React.createElement(Box, { sx: { display: 'flex', flex: '1 50%', gap: 2, alignItems: 'center' } },
                    React.createElement(AccountMembershipOrgAvatar, { organizationId: props.organizationId, organizationName: props.organizationName, hasLogo: props.hasLogo }),
                    React.createElement(Box, null, props.organizationName)),
                React.createElement(Box, { sx: { display: 'flex', flex: '1 50%', gap: 2, alignItems: 'center' } },
                    props.status && React.createElement(AccountMembershipStatus, { status: props.status }),
                    props.role && (React.createElement(Box, { sx: { flex: '1 50%' }, "data-test": 'membership-role' }, (_a = orgRoleMap[props.role]) === null || _a === void 0 ? void 0 : _a.label)))),
            React.createElement(Box, { sx: { flex: '1 25%' } },
                React.createElement(AccountMembershipActions, { canManageMembership: canManageMembership, organizationId: props.organizationId, status: props.status, role: props.role, memberFullName: props.memberFullName, onUpdateMembership: props.onUpdateMembership, organizationName: props.organizationName, onOpenSlideout: props.onOpenSlideout })))));
};
